import { useContext, useEffect, useState } from 'react'

import {
  Box,
  Button,
  Icon,
  Input,
  Pagination,
  Text,
} from '@fairfashion/design-system'
import { useNavigate } from 'react-router-dom'

import { ProviderItemsContext } from '../../provider-items.context'
import { PendingItemCard } from '../PendingInvoiceCard/pending-invoice-card.comp'

import * as Styles from './pending-items-tab.styles'

export const PendingItemsTab = () => {
  const [filter, setFilter] = useState<string>('')
  const [page, setPage] = useState<number>(1)

  const { pendingItems, pendingItemsCount, actions } =
    useContext(ProviderItemsContext)

  const navigate = useNavigate()

  const fetchPendingItems = () => {
    actions.fetchPendingItems(page, filter)
  }

  useEffect(() => {
    fetchPendingItems()
  }, [page])

  useEffect(() => {
    if (filter.length === 0) {
      fetchPendingItems()
    }
  }, [filter])

  const handleClickCard = (itemId: string) => {
    navigate(`/origins/${itemId}`)
  }

  return (
    <Box direction="column" width="100%">
      <Box width="100%" gap={2} justifyContent="flex-end">
        <Input
          placeholder="Busque pelo item, nota fiscal ou cliente"
          adornment={<Icon name="search" color="grey_2" />}
          adornmentPosition="left"
          width="400px"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
        <Button onClick={fetchPendingItems}>Pesquisar</Button>
      </Box>
      <Box marginTop={3} width="100%" direction="column">
        {pendingItemsCount > 0 ? (
          <>
            <Styles.PendingItemsContainer width="100%" flexWrap="wrap" gap={3}>
              {pendingItems.map((item, index) => (
                <Box key={`pending-invoice-${index}`}>
                  <PendingItemCard
                    item={item}
                    onClick={() => handleClickCard(item.id)}
                  />
                </Box>
              ))}
            </Styles.PendingItemsContainer>
            <Box width="100%" justifyContent="center" paddingY={3}>
              <Pagination
                total={Math.ceil(pendingItemsCount / 12)}
                current={page}
                onChange={(_page) => setPage(_page)}
              />
            </Box>
          </>
        ) : (
          <Box
            height="100px"
            width="100%"
            justifyContent="center"
            alignItems="center"
          >
            <Text color="grey_3">Nenhum item pendente encontrado</Text>
          </Box>
        )}
      </Box>
    </Box>
  )
}
